export const welcomeSectionData = {
  title: 'How does Home Price Protection help sellers?',
  subtitle:
    'Real estate values are like most investments, they go up and inevitably go down. Home Price Protection can help offset losses to your property’s value when prices decline.',
}

export const listItemsArr = [
  {
    highlighted: 'Enhance listing:',
    mainText: ' Helps make property more attractive to potential buyers.',
  },
  {
    highlighted: 'Gain competitive edge:',
    mainText: ' Provides a unique selling point to differentiate the home.',
  },
  {
    highlighted: 'Tackle market concerns:',
    mainText: ' Addresses buyer reservations about future market dips.',
  },
  {
    highlighted: 'Preserve listing price:',
    mainText: ' Serves as an alternative incentive to reducing property price.',
  },
  {
    highlighted: 'Revive stale listing:',
    mainText:
      ' Sparks new interest in properties that have been on the market longer than expected.',
  },
]
